import { render, staticRenderFns } from "./Mk.vue?vue&type=template&id=c056ef46&"
import script from "./Mk.vue?vue&type=script&lang=js&"
export * from "./Mk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports